import { render, staticRenderFns } from "./ActionCorreosDeCambio.vue?vue&type=template&id=f79fdcee&lang=pug"
import script from "./ActionCorreosDeCambio.vue?vue&type=script&lang=js"
export * from "./ActionCorreosDeCambio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports